
export const SCHOOLSECTIONS = {
  REMOVE_SCHOOL_SECTION_BY_INDEX: 'REMOVE_SCHOOL_SECTION_BY_INDEX',
  REMOVE_SCHOOL_SECTION_BY_ID: 'REMOVE_SCHOOL_SECTION_BY_ID',
  SET_SCHOOL_SECTIONS_BY_SCHOOL: 'SET_SCHOOL_SECTIONS_BY_SCHOOL',
  SET_SCHOOL_SECTION_BY_INDEX: 'SET_SCHOOL_SECTION_BY_INDEX',
  SET_SCHOOL_SECTION_BY_ID: 'SET_SCHOOL_SECTION_BY_ID',
  SET_NEW_SCHOOL_SECTION: 'SET_NEW_SCHOOL_SECTION'
}
